import moment from "moment";
import { useEffect, useState } from "react";
import { Modal, TextInput } from "risa-oasis-ui_v2";
import { DateRangeCalendarNew } from "../../DateRangeCalendar/DateRangeCalendar";

interface AnalyticsDatePickerModalProps {
  onClose: () => void;
  onDateRangeSelect: (startDate: Date, endDate: Date) => void;
  startDate?: Date;
  endDate?: Date;
  isLoading?: boolean;
  maxRecords?: number;
}

const AnalyticsDatePickerModal = ({
  onClose,
  onDateRangeSelect,
  startDate: startDateProp,
  endDate: endDateProp,
  isLoading,
  maxRecords,
}: AnalyticsDatePickerModalProps) => {
  const [dateRange, setDateRange] = useState<{
    startDate: Date | undefined;
    endDate: Date | undefined;
  }>({
    startDate: startDateProp ? new Date(startDateProp) : undefined,
    endDate: endDateProp ? new Date(endDateProp) : undefined,
  });

  useEffect(() => {
    if (startDateProp && endDateProp) {
      setDateRange({
        startDate: new Date(startDateProp),
        endDate: new Date(endDateProp),
      });
    }
  }, [startDateProp, endDateProp]);

  const handleSave = () => {
    onDateRangeSelect(dateRange.startDate as Date, dateRange.endDate as Date);
    onClose();
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <Modal
      dialogId="analytics-date-picker-modal"
      title="Select Date Range"
      onCancel={handleCancel}
      onSave={handleSave}
      saveButtonText={isLoading ? "Fetching data..." : "Apply"}
      cancelText="Cancel"
      onClose={handleCancel}
      disableSave={isLoading}
    >
      <div className="modal-body-wrapper m-auto w-96 items-center justify-center gap-3">
        <div className="flex flex-col items-center justify-center gap-3">
          {maxRecords && (
            <div className="export-information rounded border border-secondaryYellow-5 bg-secondaryYellow-11 p-2 text-center text-tiny text-primaryGray-4">
              A maximum of<strong> {maxRecords} records</strong> can be exported
              at a time.
              <br /> Please be aware that any filters applied within the
              application <strong>will not be applied</strong> to the exported
              data.
            </div>
          )}
          <div className="date-boxes flex justify-between gap-3">
            <TextInput
              label="From Date"
              defaultValue={moment(dateRange.startDate).format("MM/DD/YYYY")}
              id="start-date"
              readOnly
            />
            <TextInput
              label="To Date"
              defaultValue={moment(dateRange.endDate).format("MM/DD/YYYY")}
              id="end-date"
              readOnly
            />
          </div>
          <DateRangeCalendarNew
            initialStartDate={
              dateRange.startDate ? new Date(dateRange.startDate) : undefined
            }
            initialEndDate={
              dateRange.endDate ? new Date(dateRange.endDate) : undefined
            }
            onDateRangeChange={(startDate, endDate) => {
              if (startDate && endDate) {
                setDateRange({ startDate, endDate });
              }
            }}
          />
        </div>
      </div>
    </Modal>
  );
};

export default AnalyticsDatePickerModal;
